import React from "react";
import { useStore } from "../../store/store";

function useCornerTypeSelection() {
  const addToQuote = useStore((state) => state.addToQuote);

  const cornerType = useStore((state) => state.quote.cornerType);

  const handleClick = (type: "Outside" | "Inside") => {
    addToQuote({
      cornerType: type,
      jamb: "",
      addScreen: "",
      screenPocket: "",
      screenColor: "",
      screenType: "",
    });
  };

  return {
    handleClick,
    cornerType,
  };
}

export default useCornerTypeSelection;
